var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: !_vm.dataLoaded,
      expression: "!dataLoaded"
    }]
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('PageTitle', {
    attrs: {
      "title": "Учебные периоды"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "white--text px-4",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v("Добавить ")], 1)], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('PageTable', {
    attrs: {
      "table-loading": _vm.tableLoading,
      "table-headers": _vm.tableHeaders,
      "table-items": _vm.localSubmissionSessionParent.list
    },
    on: {
      "get-data": _vm.loadMore
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex align-center justify-end pa-2"
        }, [_c('v-badge', {
          attrs: {
            "overlap": "",
            "dot": "",
            "value": _vm.hasActiveFilter
          }
        }, [_c('v-btn', {
          staticClass: "white--text filter-btn",
          attrs: {
            "small": "",
            "rounded": "",
            "outlined": "",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              _vm.showFilter = !_vm.showFilter;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-filter-outline")]), _c('span', [_vm._v(_vm._s(_vm.showFilter ? 'Закрыть' : 'Фильтр'))])], 1)], 1)], 1)];
      },
      proxy: true
    }, {
      key: "item.semester",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.getSemesterName(item.semester)) + " ")];
      }
    }, {
      key: "item.year",
      fn: function fn(_ref2) {
        var _item$year;

        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(((_item$year = item.year) === null || _item$year === void 0 ? void 0 : _item$year.name) || '-') + " ")];
      }
    }, {
      key: "item.isActual",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-chip', {
          attrs: {
            "color": item.isActual ? 'success' : 'grey',
            "small": "",
            "dark": ""
          }
        }, [_vm._v(" " + _vm._s(item.isActual ? 'Активен' : 'Неактивен') + " ")])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('v-icon', {
          staticClass: "mr-1 edit-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Редактировать"
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v(" mdi-pencil-outline ")]), _c('v-icon', {
          staticClass: "remove-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Удалить"
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v(" mdi-trash-can-outline ")])];
      }
    }, {
      key: "footer",
      fn: function fn() {
        return [_c('div', {
          ref: "scrollTrigger",
          staticClass: "infinite-scroll-trigger py-4 text-center"
        }, [_vm.loadingMore ? _c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "primary",
            "size": "30",
            "width": "3"
          }
        }) : _vm._e()], 1)];
      },
      proxy: true
    }])
  })], 1), _c('SubmissionSessionDialog', {
    attrs: {
      "dialog": _vm.dialog,
      "loading": _vm.btnLoading,
      "selectedItem": _vm.selectedItem
    },
    on: {
      "saveSubmissionSession": _vm.saveSubmissionSession,
      "closeModal": _vm.closeDialog
    }
  }), _c('ConfirmDialog', {
    attrs: {
      "dialog": _vm.confirmDialog,
      "loading": _vm.btnLoading,
      "message": "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0443\u0447\u0435\u0431\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434?"
    },
    on: {
      "confirm": _vm.removeSubmissionSession,
      "closeModal": _vm.closeDialog
    }
  }), _c('transition', {
    attrs: {
      "name": "filter"
    }
  }, [_c('SubmissionSessionFilter', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showFilter,
      expression: "showFilter"
    }],
    attrs: {
      "filter": _vm.submissionFilter,
      "width-filter": 300,
      "top": 229,
      "right": 29
    },
    on: {
      "applyFilter": _vm.applyFilter,
      "closeFilter": function closeFilter($event) {
        _vm.showFilter = false;
      }
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }